// src/features/inventory/hooks/useProductGroups.js
import { useState, useCallback } from 'react';
import { productGroupsAPI } from '../services/productGroups';
import { useApi } from '../../../hooks/api/useApi';

export function useProductGroups() {
  const [productGroups, setProductGroups] = useState([]);
  const { loading, error, execute, clearError } = useApi();

  const fetchProductGroups = useCallback(async () => {
    const result = await execute(() => productGroupsAPI.getProductGroups());
    if (result.success) {
      setProductGroups(result.data.data || []);
    }
    return result;
  }, [execute]);

  const createProductGroup = useCallback(async ({
    code,
    name,
    description = null,
    lot_tracked = false,
    inventory_tracked = true,
    serial_tracked = false,
    hazardous = false,
    shelf_life_days = null,
  }) => {
    const result = await execute(() =>
      productGroupsAPI.createProductGroup({
        code,
        name,
        description,
        lot_tracked,
        inventory_tracked,
        serial_tracked,
        hazardous,
        shelf_life_days,
      })
    );
    if (result.success) {
      setProductGroups(prev => [...prev, result.data.data]);
    }
    return result;
  }, [execute]);

  const updateProductGroup = useCallback(async (productGroupId, {
    name,
    description,
    lot_tracked,
    inventory_tracked,
    serial_tracked,
    hazardous,
    shelf_life_days,
    active,
  }) => {
    const result = await execute(() =>
      productGroupsAPI.updateProductGroup(productGroupId, {
        name,
        description,
        lot_tracked,
        inventory_tracked,
        serial_tracked,
        hazardous,
        shelf_life_days,
        active,
      })
    );
    if (result.success) {
      setProductGroups(prev =>
        prev.map(pg => pg.product_group_id === productGroupId ? result.data.data : pg)
      );
    }
    return result;
  }, [execute]);

  const deleteProductGroup = useCallback(async (productGroupId) => {
    const result = await execute(() => productGroupsAPI.deleteProductGroup(productGroupId));
    if (result.success) {
      setProductGroups(prev => prev.filter(pg => pg.product_group_id !== productGroupId));
    }
    return result;
  }, [execute]);

  return {
    productGroups,
    loading,
    error,
    clearError,
    fetchProductGroups,
    createProductGroup,
    updateProductGroup,
    deleteProductGroup,
  };
}
